<template>
  <div>
    <v-container class="py-10">
      <!-- Headline -->
      <div style="text-align: center;" class="mb-10">
        <h1>Warum wir der richtige Partner sind</h1>
      </div>

      <!-- Bullet Points -->
      <div style="max-width: 1200px; margin: auto">
        <v-row>
          <v-col cols="12" sm="6" v-for="(el, i) in elements" :key="i">
            <div style="text-align: center; max-width: 400px; margin: auto" v-if="el.title !== 'Erfahrenes Team'">
              <v-icon size="60" class="mb-2">
                ${{ el.icon }}
              </v-icon>
              <p class="title">
                {{ el.title }}
              </p>
              <p>
                {{ el.text }}
              </p>
            </div>
            <div style="text-align: center; max-width: 400px; margin: auto" v-else>
              <v-icon size="60" class="mb-2">
                ${{ el.icon }}
              </v-icon>
              <p class="title">
                {{ el.title }}
              </p>
              <p>
                Wir sind an zwei der größten Trauerseiten angebunden (<a href="https://unvergessen.de/" target="_blank">Seite 1</a> | <a href="https://facebook.com/UnvergessenDuFehlst" target="_blank">Seite 2</a>) und teilen gerne unsere Erfahrungen mit Ihnen.
              </p>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <div style="background-color: #95B4A6; padding: 2%; text-align: center" :style="{ 'line-height': $vuetify.breakpoint.sm ? '40px' : '' }" v-if="!$vuetify.breakpoint.xs">
      <span class="bullet-point">
        <v-icon size="30" class="mr-2" color="white">mdi-check-circle</v-icon>
        Traueranzeige
      </span>
      <span class="bullet-point">
        <v-icon size="30" class="mr-2" color="white">mdi-check-circle</v-icon>
        Danksagung
      </span>
      <span class="bullet-point">
        <v-icon size="30" class="mr-2" color="white">mdi-check-circle</v-icon>
        Nachruf
      </span><br v-if="$vuetify.breakpoint.smAndDown">
      <span class="bullet-point">
        <v-icon size="30" class="mr-2" color="white">mdi-check-circle</v-icon>
        Jahresgedächtnis
      </span>
      <span class="bullet-point">
        <v-icon size="30" class="mr-2" color="white">mdi-check-circle</v-icon>
        Gedenkseite
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      elements: [
        {
          icon: 'money',
          title: 'Kostenfreies Angebot',
          text: 'Es gibt keine Gebühren und keine versteckten Kosten. Die Provisionen vom Verlag erhalten Sie weiterhin.'
        },
        {
          icon: 'people',
          title: 'Erfahrenes Team',
          text: 'Wir sind an zwei der größten Trauerseiten angebunden (Seite 1 | Seite 2) und teilen gerne unsere Erfahrungen mit Ihnen.'
        },
        {
          icon: 'world',
          title: 'Hohe Verbreitung',
          text: 'Wir erreichen täglich über 100.000 Trauernde und über unseren E-Mail-Verteiler werden Anzeigen schnell bundesweit verbreitet.'
        },
        {
          icon: 'faq-man',
          title: 'Fester Ansprechpartner',
          text: 'Sie erreichen uns in unserem Live-Chat oder telefonisch und haben verlagsübergreifend nur einen Ansprechpartner.'
        },
      ]
    }
  }
}
</script>

<style scoped>
.bullet-point {
  color: white !important;
  margin-right: 50px
}
</style>
